<div fxFlex="34" class="sideImage" #sideimage>
  <img src="assets/images/backgrounds/request_data.jpg" alt="">
</div>
<ng-container *ngFor="let requirement of modelService.lead.requirements">
  <div fxFlex="66" class="requestData" *ngIf="detailGathering" fxLayout="row wrap">
    <div class="infoSet" [class.slideOutFromLeft]="slideOut" fxFlex="100" fxLayout="row wrap">
      <div class="head" fxFlex="100">
        <h5>Leasing Terms</h5>
      </div>
      <div fxFlex="100" class="inputs inputMaxWidth" fxLayout="row wrap">

        <app-new-money-field [(amount)]="model.per_diem_charge" [(currency)]="model.per_diem_charge_currency"
          [isEditable]="true" label="Per Diem charge" name="per_diem_charge" fxFlex="100" fxFlex.gt-xs="13.8em"
          fxLayout="column"></app-new-money-field>

        <div fxFlex="100" fxFlex.gt-xs="14.8em" fxLayout="column">
          <div class="inputTitle">
            <span>I am open for Negotiation</span>
            <mat-slide-toggle checked color="primary" (click)="toggleNegotiation()"></mat-slide-toggle>
          </div>
          <app-percent-field [(ngModel)]="model.negotiation_percent" *ngIf="is_open_for_negotiation"
            [(errors)]="model.error.negotiation_percent" [isEditable]="true"
            [minValue]="model.validations.negotiation_percent.min"
            [maxValue]="model.validations.negotiation_percent.max" name="negotiation_percent" class="inputNego"
            type="number"></app-percent-field>
        </div>

        <app-date-field [(ngModel)]="model.tentative_pickup_date" [(errors)]="model.error.tentative_pickup_date"
          [isEditable]="true" [minDate]="model.validations.tentative_pickup_date.minDate"
          class="align-items-center readiness" label="Tentative Pick-up start date" fxFlex="100" fxFlex.gt-xs="13.8em"
          fxLayout="column"></app-date-field>

        <div fxFlex="100" fxFlex.gt-xs="13.8em" fxLayout="column">
          <div class="inputTitle">
            <span>Manufacturing Year of Containers</span>
          </div>
          <div class="perVal">
            <div fxLayout="row" class="w-100">
              <div fxFlex="50" fxLayout="row">
                <input [(ngModel)]="model.min_manufacturing_year" matInput type="number" name="purchase_price"
                  [min]="model.validations.min_manufacturing_year.min"
                  [max]="model.validations.min_manufacturing_year.max" placeholder="e.g. 2000" value="2000">
                -
              </div>
              <div fxFlex="50">
                <input [(ngModel)]="model.max_manufacturing_year" matInput type="number" name="purchase_price"
                  [min]="model.validations.max_manufacturing_year.min"
                  [max]="model.validations.max_manufacturing_year.max" placeholder="e.g. 2022">
              </div>

            </div>
          </div>
          <ul *ngIf="model.error.min_manufacturing_year?.length || model.error.max_manufacturing_year?.length"
            class="errorList">
            <li *ngFor="let item of model.error.min_manufacturing_year" class="error">{{item}}</li>
            <li *ngFor="let item of model.error.max_manufacturing_year" class="error">{{item}}</li>
          </ul>
        </div>

        <app-text-field [(ngModel)]="model.remarks" [(errors)]="model.error.remarks" [isEditable]="true" label="Remarks"
          class="align-items-center remarks" name="remarks" fxFlex="100" fxFlex.gt-xs="13.8em" [isMultiline]="true"
          fxLayout="column"></app-text-field>

      </div>
    </div>
    <!-- <div class="infoSet" [class.slideOutFromLeft]="slideOut" fxFlex="100" fxLayout="row wrap">
    <div class="head headCom" fxFlex="100" fxLayout="row wrap">
      <h5>Communications</h5>
    </div>
    <div fxFlex="100" class="inputs" fxLayout="row wrap">

      <app-text-field [(ngModel)]="model.email" [isEditable]="true" label="Email" class="align-items-center email"
        fxFlex="100" fxFlex.gt-md="17.9em" fxLayout="column"></app-text-field>

      <app-phone-field [(ngModel)]="model.phone" [isEditable]="true" label="Contact Number"
        class="align-items-center contact" fxFlex="100" fxFlex.gt-md="17.9em" fxLayout="column"></app-phone-field>

      <div fxFlex="100" fxFlex.gt-md="17.9em" fxLayout="column" class="whatsapp">
        <mat-slide-toggle color="primary" (keydown.space)="onEnter()" (click)="onEnter()"
          [class.slideWhatsapp]="whatsapp">
          <ng-container *ngIf="!whatsapp">
            send at <img class="icon" src="/assets/images/icons/whatsapp.svg" alt="">
          </ng-container>

        </mat-slide-toggle>
        <div *ngIf="whatsapp" style="position: absolute;
        right: -1.7em;">
          <app-phone-field [(ngModel)]="model.whatsapp_number" [(errors)]="model.error.whatsapp_number"
            [isEditable]="true" label="WhatsApp Number" class="setWhatsapp contact" fxFlex="100" fxFlex.gt-md="17.9em"
            fxLayout="column"></app-phone-field>
        </div>
      </div>

    </div>
  </div> -->
    <div class="tnc" [class.slideOutFromLeft]="slideOut" fxFlex="100">
      <mat-checkbox color="primary" [(ngModel)]="checked">I've read the <i> terms and conditions</i> and abide by the
        platform's data rules.
      </mat-checkbox>
    </div>
    <div class="btn2" [class.slideOutFromLeft]="slideOut" fxFlex="100" fxLayout="row">
      <button mat-raised-button class="Cancel" (click)="skip()">Skip</button>

      <button mat-raised-button class="Save" (click)="navigateToLogin(requirement)"
        [disabled]="!checked || savingCommercials">Proceed</button>

    </div>
  </div>
</ng-container>
<div fxFlex="66" *ngIf="!detailGathering" fxLayout="column wrap" class="confirmation" #confirmation>
<!--  <ng-container *ngIf="celebrate">-->
<!--    <ng-particles id="tsparticles" [options]="rain" [particlesInit]="particlesInit">-->
<!--    </ng-particles>-->
<!--  </ng-container>-->
  <div class="confirmationData" [class.slideInFromLeft]="slideIn">
    <h5>Thank You!</h5>
    <span>
      Your request is submitted successfully. For future
      correspondence please keep Ref no:<mat-chip #requestNo class="fw-medium"
        [cdkCopyToClipboard]="modelService.lead.request_number" matTooltip="Click to copy" matTooltipPosition="right"
        selected color="primary">{{modelService.lead.request_number}}</mat-chip>
    </span>

  </div>
  <button mat-raised-button class="homebtn Save" [class.slideInFromLeft]="slideIn" (click)="skip()">
    View request list</button>
  <!-- <button mat-raised-button class="homebtn Save" [class.slideInFromLeft]="slideIn" (click)="navigateToLogin()">Take me Home</button> -->

</div>
